import axios from "axios";
import URLS from "../util/urls.js";

const state = {
  imobiliarias: [],
  qtdImobiliarias: 0,

  imobiliariaSelecionada: {
    id: 0,
    bloqueada: false,
    exibirNoImoveis: false,
    nome: '',
    creci: '',
    razaoSocial: '',
    cnpj: '',
    nomeRepresentante: '',
    cpfRepresentante: '',
    telefone: '',
    celular: '',
    whatsapp: '',
    whatsappVenda: '',
    email: '',
    emailFinanceiro: '',
    emailPortais: '',
    site: '',
    endereco: '',
    numeroEndereco: '',
    complemento: '',
    cep: '',
    estado: { id: 0, sigla: '' },
    cidade: { id: 0, nome: '' },
    bairro: { id: 0, nome: '' },
    numeracao: {
      idImovelCorrente: 0,
      idClienteCorrente: 0,
      numeroReciboCorrente: 0,
    },
    imoveisVendidos: 0,
    imoveisLocados: 0,
    imoveisEmDesocupacao: 0,
    imoveisReservados: 0,
    imoveisDisponiveis: 0,
    imoveisIndisponiveis: 0,
    imoveisArquivados: 0,
    valorEmailSite: 0,
    tabelaPreco: '',
    diaVencimentoFatura: 0,
    percentualDescontoMensalidade: 0,
    statusContratoSAC: 'ATIVO',
    moduloAluguel: false,
    moduloVenda: false,
    moduloFinanceiro: false,
    appVistoria: false,
    avisoVencimentoProximo: false,
    avisoAposVencimento: false,
    emailAcompanhamentoImovel: false,
    emailAniversario: false,
    horaExecucaoEmailBoleto: 7,
    horaExecucaoEmailAcompanhamentoImovel: 7,
    horaExecucaoEmailAniversario: 7,
    parametrosSite: {
      status: undefined
    },
    propostaComercial: {
      data: '',
      vendedor: '',
      plano100: 0,
      plano250: 0,
      plano500: 0,
      plano1000: 0,
      plano2000: 0,
      plano3000: 0,
      plano3000mais: 0,
    },
    usuarios: [],
  },

  parametrosSite: {
    modelo: 'MODELO_1',
    latitude: '',
    longitude: '',
    chaveAnalytics: '',
    chaveJivoChat: '',
    serverName: '',
    serverAlias: '',
    corPrincipal: '',
    corPrincipalHover: '',
    corSecundaria: '',
    corFundoClaro: '',
    corFundoClaroSec: '',
    corTexto: '',
    corInativo: '',
    inverterHeader: false,
    fixarHeader: false,
    menuBranco: false,
    quemSomos: '',
    missao: '',
    visao: '',
    tituloServicos1: '',
    textoServicos1: '',
    tituloServicos2: '',
    textoServicos2: '',
    tituloServicos3: '',
    textoServicos3: '',
    linksUteis: [],
  },

  cidades: [],
  bairros: [],
  imobiliariasDisponiveis: [],
  imobiliariasParceiras: [],
}

const mutations = {
  setImobiliarias(state, imobiliarias) {
    state.imobiliarias = imobiliarias;
  },

  setQtdImobiliarias(state, qtdImobiliarias) {
    state.qtdImobiliarias = qtdImobiliarias;
  },

  setImobiliariaSelecionada(state, imobiliaria) {
    state.imobiliariaSelecionada = imobiliaria;

    if(imobiliaria.propostaComercial === null) {
      state.imobiliariaSelecionada.propostaComercial = {
        data: '',
        vendedor: '',
        plano100: 0,
        plano250: 0,
        plano500: 0,
        plano1000: 0,
        plano2000: 0,
        plano3000: 0,
        plano3000mais: 0,
      };
    }

    state.cidades = [imobiliaria.cidade];
    state.bairros = [imobiliaria.bairro];
  },

  setCidades(state, cidades) {
    state.cidades = cidades;
  },
  setBairros(state, bairros) {
    state.bairros = bairros;
  },

  limparFormImobiliaria(state) {
    state.cidades = [];
    state.bairros = [];
    
    state.imobiliariaSelecionada = {
      id: 0,
      bloqueada: false,
      exibirNoImoveis: false,
      nome: '',
      creci: '',
      razaoSocial: '',
      cnpj: '',
      nomeRepresentante: '',
      cpfRepresentante: '',
      telefone: '',
      celular: '',
      whatsapp: '',
      whatsappVenda: '',
      email: '',
      emailFinanceiro: '',
      emailPortais: '',
      site: '',
      endereco: '',
      numeroEndereco: '',
      complemento: '',
      cep: '',
      estado: { id: 0, sigla: '' },
      cidade: { id: 0, nome: '' },
      bairro: { id: 0, nome: '' },
      numeracao: {
        idImovelCorrente: 0,
        idClienteCorrente: 0,
        numeroReciboCorrente: 0,
      },
      imoveisVendidos: 0,
      imoveisLocados: 0,
      imoveisEmDesocupacao: 0,
      imoveisReservados: 0,
      imoveisDisponiveis: 0,
      imoveisIndisponiveis: 0,
      imoveisArquivados: 0,
      valorEmailSite: 0,
      tabelaPreco: '',
      diaVencimentoFatura: 0,
      percentualDescontoMensalidade: 0,
      statusContratoSAC: 'ATIVO',
      moduloAluguel: false,
      moduloVenda: false,
      moduloFinanceiro: false,
      contasEmail: false,
      appVistoria: false,
      avisoVencimentoProximo: false,
      avisoAposVencimento: false,
      emailAcompanhamentoImovel: false,
      emailAniversario: false,
      horaExecucaoEmailBoleto: 7,
      horaExecucaoEmailAcompanhamentoImovel: 7,
      horaExecucaoEmailAniversario: 7,
      parametrosSite: {
        status: undefined
      },
      propostaComercial: {
        data: '',
        vendedor: '',
        plano100: 0,
        plano250: 0,
        plano500: 0,
        plano1000: 0,
        plano2000: 0,
        plano3000: 0,
        plano3000mais: 0,
      },
      usuarios: [],
    };
  },

  limparFormParametrosSite(state) {
    state.parametrosSite = {
      modelo: 'MODELO_1',
      latitude: '',
      longitude: '',
      chaveAnalytics: '',
      chaveJivoChat: '',
      serverName: '',
      serverAlias: '',
      corPrincipal: '',
      corPrincipalHover: '',
      corSecundaria: '',
      corFundoClaro: '',
      corFundoClaroSec: '',
      corTexto: '',
      corInativo: '',
      inverterHeader: false,
      fixarHeader: false,
      menuBranco: false,
      quemSomos: '',
      missao: '',
      visao: '',
      tituloServicos1: '',
      textoServicos1: '',
      tituloServicos2: '',
      textoServicos2: '',
      tituloServicos3: '',
      textoServicos3: '',
      linksUteis: [],
    };
  },

  setParametrosSite(state, parametros) {
    if(parametros === null) {
      state.parametrosSite = {
        modelo: 'MODELO_1',
        latitude: '',
        longitude: '',
        chaveAnalytics: '',
        chaveJivoChat: '',
        serverName: '',
        serverAlias: '',
        corPrincipal: '',
        corPrincipalHover: '',
        corSecundaria: '',
        corFundoClaro: '',
        corFundoClaroSec: '',
        corTexto: '',
        corInativo: '',
        inverterHeader: false,
        fixarHeader: false,
        menuBranco: false,
        quemSomos: '',
        missao: '',
        visao: '',
        tituloServicos1: '',
        textoServicos1: '',
        tituloServicos2: '',
        textoServicos2: '',
        tituloServicos3: '',
        textoServicos3: '',
        linksUteis: [],
      };
      return;
    }

    state.parametrosSite = parametros;
  },

  limparCidade(state) {
    state.imobiliariaSelecionada.cidade = { id: 0, nome: '' };
    state.cidades = [];
  },

  limparBairro(state) {
    state.imobiliariaSelecionada.bairro = { id: 0, nome: '' };
    state.bairros = [];
  },

  preencherFormularioComPreCadastro(state, preCadastro) {
    state.imobiliariaSelecionada.razaoSocial = preCadastro.razaoSocial;
    state.imobiliariaSelecionada.cnpj = preCadastro.cnpj;
    state.imobiliariaSelecionada.endereco = preCadastro.endereco;
    state.imobiliariaSelecionada.numeroEndereco = preCadastro.numeroEndereco;
    state.imobiliariaSelecionada.complemento = preCadastro.complemento;
    state.imobiliariaSelecionada.cep = preCadastro.cep;

    if(preCadastro.estado.id !== 0) {
      state.imobiliariaSelecionada.estado = preCadastro.estado;
    }

    if(preCadastro.cidade.id !== 0) {
      state.imobiliariaSelecionada.cidade = preCadastro.cidade;
      state.cidades = [preCadastro.cidade];
    }

    if(preCadastro.bairro.id !== 0) {
      state.imobiliariaSelecionada.bairro = preCadastro.bairro;
      state.bairros = [preCadastro.bairro];
    }

    state.imobiliariaSelecionada.nomeRepresentante = preCadastro.nomeRepresentante;
    state.imobiliariaSelecionada.cpfRepresentante = preCadastro.cpfRepresentante;
    state.imobiliariaSelecionada.statusContratoSAC = 'ATIVO'

    if(preCadastro.propostaComercial !== null) {
      state.imobiliariaSelecionada.moduloAluguel = preCadastro.propostaComercial.aluguel;
      state.imobiliariaSelecionada.moduloVenda = preCadastro.propostaComercial.venda;
      state.imobiliariaSelecionada.appVistoria = preCadastro.propostaComercial.appVistoria;
      state.imobiliariaSelecionada.contasEmail = preCadastro.propostaComercial.contasEmail;
      state.imobiliariaSelecionada.propostaComercial.data = preCadastro.propostaComercial.data;
      state.imobiliariaSelecionada.propostaComercial.vendedor = preCadastro.propostaComercial.vendedor;
      state.imobiliariaSelecionada.propostaComercial.plano100 = preCadastro.propostaComercial.plano100;
      state.imobiliariaSelecionada.propostaComercial.plano250 = preCadastro.propostaComercial.plano250;
      state.imobiliariaSelecionada.propostaComercial.plano500 = preCadastro.propostaComercial.plano500;
      state.imobiliariaSelecionada.propostaComercial.plano1000 = preCadastro.propostaComercial.plano1000;
      state.imobiliariaSelecionada.propostaComercial.plano2000 = preCadastro.propostaComercial.plano2000;
      state.imobiliariaSelecionada.propostaComercial.plano3000 = preCadastro.propostaComercial.plano3000;
      state.imobiliariaSelecionada.propostaComercial.plano3000mais = preCadastro.propostaComercial.plano3000mais;
      state.imobiliariaSelecionada.propostaComercial.visitaTecnica = preCadastro.propostaComercial.visitaTecnica;
      state.imobiliariaSelecionada.propostaComercial.site = preCadastro.propostaComercial.site;
      state.imobiliariaSelecionada.propostaComercial.siteEmail = preCadastro.propostaComercial.siteEmail;
    }
  },

  atualizarImobiliariasDisponiveis(state, payload) {
    state.imobiliariasDisponiveis = payload
  },

  atualizarImobiliariasParceiras(state, payload) {
    state.imobiliariasParceiras = payload
  }
}

const actions = {
  listarImobiliarias(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setImobiliarias', response.data.lista);
          context.commit('setQtdImobiliarias', response.data.quantidade);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarImobiliarias", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarImobiliaria(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setImobiliariaSelecionada', response.data.item);
          context.commit('limparFormParametrosSite');
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarImobiliariaPreCadastrada(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarImobiliariaPreCadastrada", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  gravarImobiliaria(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setImobiliariaSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gravarImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  removerImobiliaria(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('limparFormImobiliaria');
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("removerImobiliaria", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarCidades(context, payload) {
    return axios.post(URLS.CIDADES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setCidades', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarCidades", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarBairros(context, payload) {
    return axios.post(URLS.BAIRROS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setBairros', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarBairros", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarParametrosSite(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_RECUPERAR_PARAMETROS_SITE, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setParametrosSite', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarParametrosSite", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  gravarParametrosSite(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_GRAVAR_PARAMETROS_SITE, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('setParametrosSite', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gravarParametrosSite", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  listarImobiliariasPreCadastradas(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PRE_CADASTRADAS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarImobiliariasPreCadastradas", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },
  
  publicarSite(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_PUBLICAR_SITE, payload)
    .then(response => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("publicarSite", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarImobiliariasDisponiveisParceiros(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImobiliariasDisponiveis', response.data.lista)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("listarImobiliariasDisponiveisParceiros", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },

  gravarImobiliariasParceiras(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_GRAVAR_IMOBILIARIAS_PARCEIRAS, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.dispatch('atualizarImobiliariasParceiras', response.data.item.imobiliariasParceiras)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarImobiliariasParceiras', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gravarUsuario", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarUsuario(context, payload) {
    return axios.post(URLS.USUARIOS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarUsuario", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  despublicarSite(context, payload) {
    return axios.post(URLS.IMOBILIARIAS_DESPUBLICAR_SITE, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit("setImobiliariaSelecionada", response.data.item)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarUsuario", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  gravarUsuarioSuporte(context, payload) {
    return axios.post(URLS.USUARIOS_GRAVAR_SUPORTE, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gravarUsuarioSuporte")
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}